import { zergApi } from "@/service/zerg";

const prefix = "monitoring/dias-libres";

class DiasLibresReportService {
  async getReporte(params) {
    try {
      const data = await zergApi.post(`${prefix}/reporte`, params);
      return data;
    } catch (error) {
      throw error;
    }
  }

  async getDetalle(params) {
    try {
      const data = await zergApi.post(`${prefix}/detalle`, params);
      return data;
    } catch (error) {
      throw error;
    }
  }

  async getAjustes(params) {
    try {
      const data = await zergApi.post(`${prefix}/ajustes`, params);
      return data;
    } catch (error) {
      throw error;
    }
  }

  async registrarAjuste(params) {
    try {
      const data = await zergApi.post(`${prefix}/registrar-ajuste`, params);
      return data;
    } catch (error) {
      throw error;
    }
  }

  async anularAjuste(params) {
    try {
      const data = await zergApi.post(`${prefix}/anular-ajuste`, params);
      return data;
    } catch (error) {
      throw error;
    }
  }

  async cargarSaldoInicial(params) {
    try {
      const data = await zergApi.post(`${prefix}/saldo-inicial`, params);
      return data;
    } catch (error) {
      throw error;
    }
  }

  async cerrarPeriodo(params) {
    try {
      const data = await zergApi.post(`${prefix}/cerrar-periodo`, params);
      return data;
    } catch (error) {
      throw error;
    }
  }

  async exportToExcel(params) {
    try {
      const data = await zergApi.post(`${prefix}/export-to-excel`, params, {
        responseType: "blob",
      });
      return data;
    } catch (error) {
      throw error;
    }
  }
}

export default new DiasLibresReportService();
